/**
 * @generated SignedSource<<6f684a78c3d141c96d3fac5833070f3f>>
 * @relayHash 358d5681ffd4b464eec8c39742fcb845
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4e278a578dc1baffc5e8f0e515cb6c3c8e3538cab4c7248a24696466acefd1a6

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type GoalPanelQuery$variables = {
  ari: string;
  capabilitiesContainerId: string;
  includeDraftUpdate: boolean;
  queryContext?: string | null;
};
export type GoalPanelQuery$data = {
  readonly goals_byId: Result<{
    readonly id: string;
    readonly key: string;
    readonly latestDraftUpdate?: {
      readonly " $fragmentSpreads": FragmentRefs<"GoalDraftUpdateAdapter_draft">;
    } | null;
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"GoalActions" | "GoalCustomFields" | "GoalFocusAreas" | "GoalFollowers" | "GoalMetrics" | "GoalOwner" | "GoalPanelTitleField" | "GoalStartDate" | "GoalStatusField" | "GoalTags" | "GoalTargetDate" | "GoalTeams" | "GoalType" | "GoalUpdateComposerCreate" | "ParentGoal" | "SubGoals">;
  } | null, unknown>;
  readonly me: {
    readonly user: {
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null;
  };
  readonly " $fragmentSpreads": FragmentRefs<"GoalPanelTabs">;
};
export type GoalPanelQuery = {
  response: GoalPanelQuery$data;
  variables: GoalPanelQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ari"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "capabilitiesContainerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeDraftUpdate"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryContext"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "picture"
},
v7 = [
  {
    "kind": "Variable",
    "name": "goalId",
    "variableName": "ari"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "key"
},
v9 = {
  "kind": "ScalarField",
  "name": "url"
},
v10 = {
  "kind": "Variable",
  "name": "queryContext",
  "variableName": "queryContext"
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "canCreateGoal"
},
v14 = {
  "kind": "ScalarField",
  "name": "canEditMetrics"
},
v15 = {
  "kind": "ScalarField",
  "name": "canManagePeriodicMetricTargets"
},
v16 = {
  "kind": "ScalarField",
  "name": "canRemoveLinkedGoals"
},
v17 = {
  "kind": "ScalarField",
  "name": "canCreateUpdates"
},
v18 = {
  "kind": "ScalarField",
  "name": "canAddLinkedProjects"
},
v19 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v20 = [
  (v8/*: any*/),
  (v4/*: any*/)
],
v21 = [
  (v4/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v24 = {
  "concreteType": "TownsquareGoalIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "appearance"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "value"
},
v26 = [
  (v25/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v28 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v27/*: any*/)
  ]
},
v29 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v8/*: any*/)
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "kind"
},
v31 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v27/*: any*/)
  ]
},
v32 = {
  "kind": "ScalarField",
  "name": "score"
},
v33 = [
  (v25/*: any*/),
  (v32/*: any*/)
],
v34 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v35 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v36 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v37 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v4/*: any*/),
    (v5/*: any*/),
    (v6/*: any*/),
    (v36/*: any*/)
  ]
},
v38 = {
  "kind": "ScalarField",
  "name": "accessLevel"
},
v39 = {
  "kind": "ScalarField",
  "name": "startDate"
},
v40 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v41 = {
  "kind": "ScalarField",
  "name": "end"
},
v42 = {
  "kind": "ScalarField",
  "name": "start"
},
v43 = {
  "kind": "ScalarField",
  "name": "confidence"
},
v44 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    (v41/*: any*/)
  ]
},
v45 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "date",
  "plural": false,
  "selections": [
    (v43/*: any*/),
    (v44/*: any*/)
  ]
},
v46 = [
  (v25/*: any*/),
  (v4/*: any*/)
],
v47 = {
  "kind": "ScalarField",
  "name": "variance"
},
v48 = {
  "concreteType": "TownsquareMetricTargetPeriodToMetricValueEdge",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValue",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v46/*: any*/)
    },
    (v47/*: any*/)
  ]
},
v49 = {
  "kind": "ScalarField",
  "name": "type"
},
v50 = {
  "kind": "ScalarField",
  "name": "subType"
},
v51 = {
  "kind": "ScalarField",
  "name": "archived"
},
v52 = {
  "kind": "ScalarField",
  "name": "externalEntityId"
},
v53 = {
  "kind": "ScalarField",
  "name": "source"
},
v54 = {
  "kind": "ScalarField",
  "name": "time"
},
v55 = [
  (v54/*: any*/),
  (v4/*: any*/),
  (v25/*: any*/)
],
v56 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v57 = [
  (v56/*: any*/),
  {
    "kind": "Literal",
    "name": "sort",
    "value": [
      "TIME_ASC"
    ]
  }
],
v58 = [
  (v12/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v59 = {
  "concreteType": "TownsquareGoalState",
  "kind": "LinkedField",
  "name": "newState",
  "plural": false,
  "selections": (v33/*: any*/)
},
v60 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v61 = {
  "kind": "ScalarField",
  "name": "endCursor"
},
v62 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v63 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v62/*: any*/)
  ]
},
v64 = {
  "args": (v57/*: any*/),
  "concreteType": "TownsquareMetricValueConnection",
  "kind": "LinkedField",
  "name": "values",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "canDelete"
            },
            (v25/*: any*/),
            (v54/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v58/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "origin",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "TownsquareGoalUpdate",
                      "kind": "LinkedField",
                      "name": "goalUpdate",
                      "plural": false,
                      "selections": [
                        (v40/*: any*/),
                        {
                          "concreteType": "TownsquareGoal",
                          "kind": "LinkedField",
                          "name": "goal",
                          "plural": false,
                          "selections": (v21/*: any*/)
                        },
                        (v59/*: any*/),
                        (v4/*: any*/)
                      ]
                    }
                  ],
                  "type": "TownsquareFromGoalUpdate"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v40/*: any*/)
                  ],
                  "type": "TownsquareFromMetricCreation"
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "updateDate"
                    }
                  ],
                  "type": "TownsquareFromMetricUpdate"
                }
              ]
            },
            (v23/*: any*/),
            (v12/*: any*/)
          ]
        },
        (v60/*: any*/)
      ]
    },
    (v63/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": "values(first:100,sort:[\"TIME_ASC\"])"
},
v65 = {
  "args": (v57/*: any*/),
  "filters": [
    "sort"
  ],
  "handle": "connection",
  "key": "SuccessMeasureChart_values",
  "kind": "LinkedHandle",
  "name": "values"
},
v66 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "snapshotValue",
  "plural": false,
  "selections": (v46/*: any*/)
},
v67 = {
  "kind": "ScalarField",
  "name": "startValue"
},
v68 = {
  "kind": "ScalarField",
  "name": "targetValue"
},
v69 = [
  (v54/*: any*/),
  (v4/*: any*/)
],
v70 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v41/*: any*/)
  ]
},
v71 = {
  "args": (v57/*: any*/),
  "concreteType": "TownsquareMetricTargetToMetricValueConnection",
  "kind": "LinkedField",
  "name": "metricValues",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetToMetricValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v69/*: any*/)
        },
        {
          "concreteType": "TownsquareMetricTargetPeriod",
          "kind": "LinkedField",
          "name": "metricTargetPeriod",
          "plural": false,
          "selections": [
            {
              "concreteType": "TownsquareTargetDate",
              "kind": "LinkedField",
              "name": "date",
              "plural": false,
              "selections": [
                (v70/*: any*/)
              ]
            },
            (v25/*: any*/)
          ]
        },
        (v47/*: any*/)
      ]
    }
  ],
  "storageKey": "metricValues(first:100,sort:[\"TIME_ASC\"])"
},
v72 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v73 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v49/*: any*/)
  ]
},
v74 = {
  "concreteType": "TownsquareGoalType",
  "kind": "LinkedField",
  "name": "goalType",
  "plural": false,
  "selections": [
    (v30/*: any*/),
    (v4/*: any*/),
    (v29/*: any*/)
  ]
},
v75 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": (v69/*: any*/)
},
v76 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                (v5/*: any*/),
                (v49/*: any*/),
                (v50/*: any*/),
                (v51/*: any*/),
                (v52/*: any*/),
                (v53/*: any*/),
                (v75/*: any*/)
              ]
            },
            (v66/*: any*/),
            (v67/*: any*/),
            (v68/*: any*/)
          ]
        }
      ]
    }
  ]
},
v77 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v33/*: any*/)
},
v78 = [
  (v44/*: any*/)
],
v79 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": (v78/*: any*/)
},
v80 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v81 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v82 = {
  "kind": "ScalarField",
  "name": "summary"
},
v83 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v84 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "TownsquareGoalUpdateConnection",
  "kind": "LinkedField",
  "name": "updates",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareGoalUpdateEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareGoalUpdate",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v80/*: any*/),
            (v81/*: any*/),
            (v82/*: any*/),
            (v83/*: any*/),
            (v40/*: any*/),
            (v4/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "updates(first:1)"
},
v85 = {
  "kind": "Literal",
  "name": "first",
  "value": 200
},
v86 = [
  (v85/*: any*/),
  {
    "kind": "Literal",
    "name": "tql",
    "value": "archived = false"
  }
],
v87 = {
  "concreteType": "TownsquareIconURIs",
  "kind": "LinkedField",
  "name": "iconUrl",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareThemeURIs",
      "kind": "LinkedField",
      "name": "roundedSquare",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "dark"
        },
        {
          "kind": "ScalarField",
          "name": "light"
        }
      ]
    }
  ]
},
v88 = {
  "concreteType": "TownsquareProjectState",
  "kind": "LinkedField",
  "name": "state",
  "plural": false,
  "selections": (v26/*: any*/)
},
v89 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "dueDate",
  "plural": false,
  "selections": (v78/*: any*/)
},
v90 = [
  (v12/*: any*/),
  (v4/*: any*/)
],
v91 = [
  {
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": (v90/*: any*/)
  }
],
v92 = {
  "concreteType": "TownsquareContributorConnection",
  "kind": "LinkedField",
  "name": "contributors",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareContributorEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareContributor",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "name": "userContributor",
              "plural": false,
              "selections": (v90/*: any*/)
            },
            {
              "concreteType": "TownsquareTeamContributor",
              "kind": "LinkedField",
              "name": "teamContributor",
              "plural": false,
              "selections": [
                {
                  "concreteType": "TownsquareUserConnection",
                  "kind": "LinkedField",
                  "name": "contributingMembers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "TownsquareUserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": (v91/*: any*/)
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
},
v93 = {
  "args": (v86/*: any*/),
  "filters": [
    "tql"
  ],
  "handle": "connection",
  "key": "GoalContentProjects_projects",
  "kind": "LinkedHandle",
  "name": "projects"
},
v94 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v95 = [
  (v49/*: any*/),
  (v72/*: any*/)
],
v96 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": (v95/*: any*/)
},
v97 = {
  "concreteType": "TownsquareGoalAppCapabilities",
  "kind": "LinkedField",
  "name": "apps",
  "plural": false,
  "selections": [
    (v15/*: any*/)
  ]
},
v98 = {
  "kind": "ScalarField",
  "name": "description"
},
v99 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v98/*: any*/)
],
v100 = [
  (v56/*: any*/)
],
v101 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v102 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v103 = [
  (v12/*: any*/),
  (v6/*: any*/),
  (v5/*: any*/),
  (v36/*: any*/),
  (v4/*: any*/)
],
v104 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v103/*: any*/)
},
v105 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v103/*: any*/)
},
v106 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v107 = [
  (v25/*: any*/),
  (v54/*: any*/),
  (v4/*: any*/)
],
v108 = [
  (v12/*: any*/),
  (v36/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/),
  (v4/*: any*/)
],
v109 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v108/*: any*/)
},
v110 = {
  "kind": "ScalarField",
  "name": "label"
},
v111 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v108/*: any*/)
},
v112 = [
  (v40/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v25/*: any*/),
      (v32/*: any*/),
      (v110/*: any*/)
    ]
  },
  (v82/*: any*/),
  (v111/*: any*/),
  {
    "concreteType": "TownsquareUpdateNoteConnection",
    "kind": "LinkedField",
    "name": "updateNotes",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareUpdateNoteEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "TownsquareUpdateNote",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v82/*: any*/),
              (v98/*: any*/),
              (v51/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v4/*: any*/),
              (v82/*: any*/),
              (v98/*: any*/),
              (v102/*: any*/),
              (v104/*: any*/),
              (v105/*: any*/),
              (v40/*: any*/),
              (v106/*: any*/)
            ]
          }
        ]
      },
      (v23/*: any*/)
    ]
  },
  (v4/*: any*/)
],
v113 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v112/*: any*/)
},
v114 = [
  (v110/*: any*/),
  (v44/*: any*/)
],
v115 = {
  "concreteType": "TownsquareCommentConnection",
  "kind": "LinkedField",
  "name": "comments",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareCommentEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareComment",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": [
                (v12/*: any*/),
                (v5/*: any*/),
                (v4/*: any*/),
                (v36/*: any*/),
                (v6/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "commentText"
            },
            (v83/*: any*/),
            (v40/*: any*/)
          ]
        }
      ]
    },
    (v23/*: any*/)
  ]
},
v116 = [
  {
    "kind": "InlineFragment",
    "selections": [
      (v82/*: any*/),
      (v98/*: any*/),
      (v104/*: any*/),
      (v105/*: any*/),
      (v40/*: any*/),
      (v106/*: any*/)
    ],
    "type": "TownsquareHighlight",
    "abstractKey": "__isTownsquareHighlight"
  }
],
v117 = [
  (v85/*: any*/),
  (v10/*: any*/)
],
v118 = [
  {
    "concreteType": "TownsquareHighlightEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": (v91/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "kind": "CatchField",
        "field": {
          "args": (v7/*: any*/),
          "concreteType": "TownsquareGoal",
          "kind": "LinkedField",
          "name": "goals_byId",
          "plural": false,
          "selections": [
            (v4/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "args": (v11/*: any*/),
              "kind": "FragmentSpread",
              "name": "GoalFocusAreas"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalPanelTitleField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStatusField"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalType"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalOwner"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalMetrics"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTargetDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "ParentGoal"
            },
            {
              "kind": "FragmentSpread",
              "name": "SubGoals"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTags"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalFollowers"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalStartDate"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalActions"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalTeams"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalCustomFields"
            },
            {
              "kind": "FragmentSpread",
              "name": "GoalUpdateComposerCreate"
            },
            {
              "condition": "includeDraftUpdate",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "concreteType": "TownsquareGoalDraftUpdate",
                  "kind": "LinkedField",
                  "name": "latestDraftUpdate",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "GoalDraftUpdateAdapter_draft"
                    }
                  ]
                }
              ]
            }
          ]
        },
        "to": "RESULT"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "ari",
            "variableName": "ari"
          },
          {
            "kind": "Variable",
            "name": "capabilitiesContainerId",
            "variableName": "capabilitiesContainerId"
          },
          {
            "kind": "Variable",
            "name": "includeDraftUpdate",
            "variableName": "includeDraftUpdate"
          },
          (v10/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalPanelTabs"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalPanelQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v12/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v7/*: any*/),
        "concreteType": "TownsquareGoal",
        "kind": "LinkedField",
        "name": "goals_byId",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canAddLinkedFocusAreas"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedFocusAreas"
              },
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareFocusAppCapabilities",
                    "kind": "LinkedField",
                    "name": "focus",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canViewFocusAreas"
                      }
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditMetadata"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStatus"
              },
              {
                "kind": "ScalarField",
                "name": "canManageOwnership"
              },
              (v14/*: any*/),
              {
                "concreteType": "TownsquareGoalAppCapabilities",
                "kind": "LinkedField",
                "name": "apps",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v13/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "canEditTargetDate"
              },
              {
                "kind": "ScalarField",
                "name": "canAddLinkedGoals"
              },
              (v16/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddTags"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTags"
              },
              {
                "kind": "ScalarField",
                "name": "canAddWatchers"
              },
              {
                "kind": "ScalarField",
                "name": "canEditStartDate"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canAddTeams"
              },
              {
                "kind": "ScalarField",
                "name": "canEditCustomFields"
              },
              (v17/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canCommentOnGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canCommentOnUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canWatchGoal"
              },
              {
                "kind": "ScalarField",
                "name": "canEditUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canDeleteUpdates"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedProjects"
              },
              (v18/*: any*/),
              {
                "kind": "ScalarField",
                "name": "canAddLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveLinkedWorkItems"
              },
              {
                "kind": "ScalarField",
                "name": "canAddJiraAlignItems"
              },
              {
                "kind": "ScalarField",
                "name": "canRemoveJiraAlignItems"
              }
            ]
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "focusAreas",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "userPermissions"
                          },
                          (v5/*: any*/),
                          (v9/*: any*/),
                          {
                            "concreteType": "MercuryFocusAreaStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          },
                          {
                            "concreteType": "MercuryFocusAreaHealth",
                            "kind": "LinkedField",
                            "name": "health",
                            "plural": false,
                            "selections": (v20/*: any*/)
                          }
                        ],
                        "type": "MercuryFocusArea"
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          (v24/*: any*/),
          (v5/*: any*/),
          {
            "concreteType": "TownsquareGoalType",
            "kind": "LinkedField",
            "name": "goalType",
            "plural": false,
            "selections": [
              (v28/*: any*/),
              (v4/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "successMeasure",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  (v4/*: any*/),
                  (v28/*: any*/),
                  (v31/*: any*/)
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareStatus",
            "kind": "LinkedField",
            "name": "status",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v32/*: any*/),
              {
                "concreteType": "TownsquareCompletionGoalState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": (v33/*: any*/)
              }
            ]
          },
          (v34/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canPostUpdate"
          },
          (v35/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          {
            "concreteType": "TownsquareTargetDate",
            "kind": "LinkedField",
            "name": "targetDate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTargetDateRange",
                "kind": "LinkedField",
                "name": "dateRange",
                "plural": false,
                "selections": [
                  (v41/*: any*/),
                  (v42/*: any*/)
                ]
              },
              (v43/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareMetricTargetConnection",
            "kind": "LinkedField",
            "name": "metricTargets",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMetricTargetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMetricTarget",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                        "kind": "LinkedField",
                        "name": "metricTargetPeriods",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetPeriod",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v45/*: any*/),
                                  (v25/*: any*/),
                                  (v12/*: any*/),
                                  (v48/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "concreteType": "TownsquareMetric",
                        "kind": "LinkedField",
                        "name": "metric",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v49/*: any*/),
                          (v50/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v53/*: any*/),
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "latestValue",
                            "plural": false,
                            "selections": (v55/*: any*/)
                          },
                          (v23/*: any*/),
                          (v64/*: any*/),
                          (v65/*: any*/)
                        ]
                      },
                      (v66/*: any*/),
                      (v67/*: any*/),
                      (v68/*: any*/),
                      (v71/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          (v73/*: any*/),
          {
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "subGoals",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v73/*: any*/),
                      (v4/*: any*/),
                      (v74/*: any*/),
                      (v35/*: any*/),
                      (v76/*: any*/),
                      (v9/*: any*/),
                      (v77/*: any*/),
                      (v5/*: any*/),
                      (v38/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v18/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v4/*: any*/),
                          (v36/*: any*/)
                        ]
                      },
                      (v79/*: any*/),
                      (v84/*: any*/),
                      (v34/*: any*/),
                      {
                        "args": (v86/*: any*/),
                        "concreteType": "TownsquareProjectConnection",
                        "kind": "LinkedField",
                        "name": "projects",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareProject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v35/*: any*/),
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v87/*: any*/),
                                  (v88/*: any*/),
                                  (v89/*: any*/),
                                  (v37/*: any*/),
                                  (v12/*: any*/),
                                  (v92/*: any*/)
                                ]
                              },
                              (v60/*: any*/),
                              (v12/*: any*/)
                            ]
                          },
                          (v63/*: any*/),
                          (v23/*: any*/)
                        ],
                        "storageKey": "projects(first:200,tql:\"archived = false\")"
                      },
                      (v93/*: any*/)
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "args": (v94/*: any*/),
            "concreteType": "TownsquareGoalConnection",
            "kind": "LinkedField",
            "name": "successMeasures",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v96/*: any*/),
                      (v51/*: any*/),
                      (v4/*: any*/),
                      (v35/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "goalType",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          (v31/*: any*/),
                          (v4/*: any*/),
                          (v29/*: any*/)
                        ]
                      },
                      (v5/*: any*/),
                      (v77/*: any*/),
                      (v19/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": (v58/*: any*/)
                      },
                      (v79/*: any*/),
                      (v84/*: any*/),
                      (v34/*: any*/),
                      (v24/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v67/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetricTargetPeriodConnection",
                                    "kind": "LinkedField",
                                    "name": "metricTargetPeriods",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriod",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v45/*: any*/),
                                              (v25/*: any*/),
                                              (v48/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  },
                                  (v4/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v5/*: any*/),
                                      (v4/*: any*/),
                                      (v64/*: any*/),
                                      (v65/*: any*/)
                                    ]
                                  },
                                  (v68/*: any*/),
                                  (v66/*: any*/),
                                  (v71/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/),
                      {
                        "concreteType": "TownsquareGoalCapabilities",
                        "kind": "LinkedField",
                        "name": "capabilities",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v14/*: any*/),
                          (v97/*: any*/)
                        ]
                      },
                      (v38/*: any*/),
                      (v39/*: any*/),
                      (v40/*: any*/)
                    ]
                  },
                  (v12/*: any*/)
                ]
              }
            ],
            "storageKey": "successMeasures(first:50)"
          },
          {
            "concreteType": "TownsquareGoalCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              (v97/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareGoal",
            "kind": "LinkedField",
            "name": "parentGoal",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v4/*: any*/),
              (v73/*: any*/),
              (v76/*: any*/),
              {
                "concreteType": "TownsquareStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": (v26/*: any*/)
              },
              (v5/*: any*/),
              {
                "concreteType": "TownsquareGoalType",
                "kind": "LinkedField",
                "name": "goalType",
                "plural": false,
                "selections": [
                  (v29/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v38/*: any*/),
              {
                "concreteType": "TownsquareGoalCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  (v16/*: any*/)
                ]
              },
              (v19/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareTagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareTagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareTag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "usageCount"
                      },
                      (v98/*: any*/)
                    ]
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  (v62/*: any*/),
                  (v61/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareUserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "count"
              },
              {
                "concreteType": "TownsquareUserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v4/*: any*/),
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareSlackConnectionConnection",
            "kind": "LinkedField",
            "name": "slackChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareSlackConnectionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareSlackConnection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareSlackChannel",
                        "kind": "LinkedField",
                        "name": "channel",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "numMembers"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "TownsquareMsteamsConnectedChannelConnection",
            "kind": "LinkedField",
            "name": "msteamsChannels",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareMsteamsConnectedChannelEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareMsteamsConnectedChannelInfo",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v86/*: any*/),
            "concreteType": "TownsquareProjectConnection",
            "kind": "LinkedField",
            "name": "projects",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "args": (v94/*: any*/),
                        "concreteType": "TownsquareTeamConnection",
                        "kind": "LinkedField",
                        "name": "teams",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareTeamEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TeamV2",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v21/*: any*/)
                              }
                            ]
                          }
                        ],
                        "storageKey": "teams(first:50)"
                      },
                      (v12/*: any*/),
                      (v88/*: any*/),
                      (v37/*: any*/),
                      (v92/*: any*/),
                      {
                        "concreteType": "TownsquareProjectUpdate",
                        "kind": "LinkedField",
                        "name": "latestUserUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareProjectPhaseDetails",
                            "kind": "LinkedField",
                            "name": "newPhase",
                            "plural": false,
                            "selections": [
                              {
                                "alias": "_id",
                                "kind": "ScalarField",
                                "name": "id"
                              }
                            ]
                          },
                          (v4/*: any*/)
                        ]
                      },
                      (v35/*: any*/),
                      (v5/*: any*/),
                      (v9/*: any*/),
                      (v87/*: any*/),
                      (v89/*: any*/)
                    ]
                  },
                  (v12/*: any*/),
                  (v60/*: any*/)
                ]
              },
              (v63/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": "projects(first:200,tql:\"archived = false\")"
          },
          (v93/*: any*/),
          {
            "concreteType": "TownsquareGoalTeamConnection",
            "kind": "LinkedField",
            "name": "teams",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalTeamEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canRemove"
                  },
                  {
                    "concreteType": "TeamV2",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "displayName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "smallAvatarImageUrl"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isVerified"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "profileUrl"
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "concreteType": "TownsquareCustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareCustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "TownsquareTextCustomFieldDefinition"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "TownsquareNumberCustomFieldDefinition"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareNumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v99/*: any*/),
                                "type": "TownsquareUserCustomFieldDefinition"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "args": (v100/*: any*/),
                            "concreteType": "TownsquareUserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v4/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isUser"
                                      },
                                      (v5/*: any*/),
                                      (v6/*: any*/)
                                    ]
                                  },
                                  (v60/*: any*/)
                                ]
                              },
                              (v63/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v100/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldUser_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareUserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v98/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "canSetMultipleValues"
                                  },
                                  {
                                    "args": (v100/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v25/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "allowedValues(first:100)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomFieldDefinition"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "args": (v100/*: any*/),
                            "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "alias": "selectValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v12/*: any*/)
                                    ]
                                  },
                                  (v60/*: any*/)
                                ]
                              },
                              (v63/*: any*/),
                              (v23/*: any*/)
                            ],
                            "storageKey": "values(first:100)"
                          },
                          {
                            "args": (v100/*: any*/),
                            "handle": "connection",
                            "key": "CustomFieldTextSelect_values",
                            "kind": "LinkedHandle",
                            "name": "values"
                          },
                          (v23/*: any*/)
                        ],
                        "type": "TownsquareTextSelectCustomField"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v101/*: any*/),
            "concreteType": "TownsquareGoalUpdateConnection",
            "kind": "LinkedField",
            "name": "updates",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalUpdateEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalUpdate",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v82/*: any*/),
                      {
                        "concreteType": "TownsquareUpdateNoteConnection",
                        "kind": "LinkedField",
                        "name": "updateNotes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareUpdateNoteEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareUpdateNote",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v82/*: any*/),
                                  (v98/*: any*/),
                                  (v4/*: any*/),
                                  (v51/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v12/*: any*/),
                      (v40/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      (v80/*: any*/),
                      (v81/*: any*/),
                      (v59/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v82/*: any*/),
                                  (v98/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/),
                                  (v102/*: any*/),
                                  (v104/*: any*/),
                                  (v105/*: any*/),
                                  (v40/*: any*/),
                                  (v106/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v23/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v53/*: any*/),
                                      (v75/*: any*/),
                                      {
                                        "args": [
                                          (v56/*: any*/),
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v107/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v107/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": (v55/*: any*/)
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/),
                                          (v51/*: any*/),
                                          (v5/*: any*/),
                                          (v49/*: any*/),
                                          (v50/*: any*/),
                                          (v52/*: any*/),
                                          (v53/*: any*/),
                                          (v75/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v42/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v25/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v4/*: any*/),
                                      (v67/*: any*/),
                                      (v68/*: any*/),
                                      (v66/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v4/*: any*/),
                          (v34/*: any*/),
                          (v51/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  (v31/*: any*/),
                                  (v4/*: any*/)
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          },
                          (v96/*: any*/),
                          {
                            "args": (v94/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v51/*: any*/),
                                      (v73/*: any*/),
                                      (v76/*: any*/),
                                      (v9/*: any*/),
                                      (v34/*: any*/),
                                      (v79/*: any*/),
                                      (v109/*: any*/),
                                      (v113/*: any*/),
                                      (v19/*: any*/),
                                      (v35/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v28/*: any*/),
                                          (v31/*: any*/),
                                          (v29/*: any*/),
                                          (v4/*: any*/)
                                        ]
                                      },
                                      (v77/*: any*/),
                                      (v84/*: any*/)
                                    ]
                                  },
                                  (v12/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v51/*: any*/),
                                      (v73/*: any*/),
                                      (v74/*: any*/),
                                      (v76/*: any*/),
                                      (v9/*: any*/),
                                      (v34/*: any*/),
                                      (v79/*: any*/),
                                      (v109/*: any*/),
                                      (v113/*: any*/),
                                      (v35/*: any*/),
                                      (v77/*: any*/),
                                      (v84/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10
                              }
                            ],
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v82/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v82/*: any*/),
                                                  (v98/*: any*/),
                                                  (v4/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          }
                        ]
                      },
                      (v111/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v114/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareGoalProgress",
                        "kind": "LinkedField",
                        "name": "newProgress",
                        "plural": false,
                        "selections": (v95/*: any*/)
                      },
                      {
                        "args": (v94/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v72/*: any*/)
                                    ]
                                  },
                                  (v4/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v112/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v96/*: any*/),
                                  (v76/*: any*/),
                                  (v9/*: any*/),
                                  (v34/*: any*/),
                                  (v79/*: any*/),
                                  (v109/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v36/*: any*/),
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      (v83/*: any*/),
                      {
                        "args": (v100/*: any*/),
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v4/*: any*/),
                                      (v5/*: any*/),
                                      (v36/*: any*/),
                                      (v6/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v4/*: any*/)
                            ]
                          }
                        ],
                        "storageKey": "viewers(first:100)"
                      },
                      (v9/*: any*/),
                      (v115/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v33/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v114/*: any*/)
                      }
                    ]
                  },
                  (v60/*: any*/)
                ]
              },
              (v63/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": "updates(first:20)"
          },
          {
            "args": (v101/*: any*/),
            "handle": "connection",
            "key": "UpdatesList__updates",
            "kind": "LinkedHandle",
            "name": "updates"
          },
          {
            "concreteType": "TownsquareGoalUpdate",
            "kind": "LinkedField",
            "name": "latestUserUpdate",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareGoalMetricUpdateConnection",
                "kind": "LinkedField",
                "name": "metricUpdate",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "TownsquareGoalMetricUpdateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalMetricUpdate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricValue",
                            "kind": "LinkedField",
                            "name": "newValue",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v4/*: any*/)
            ]
          },
          (v98/*: any*/),
          {
            "kind": "ScalarField",
            "name": "descriptionWhy"
          },
          {
            "kind": "ScalarField",
            "name": "descriptionMeasurement"
          },
          (v115/*: any*/),
          (v51/*: any*/),
          {
            "kind": "ScalarField",
            "name": "updateStreak"
          },
          {
            "kind": "ScalarField",
            "name": "latestUpdateDate"
          },
          {
            "kind": "ScalarField",
            "name": "canEditUpdate"
          },
          {
            "kind": "ScalarField",
            "name": "isWatching"
          },
          {
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": [
              {
                "concreteType": "TownsquareHighlightEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v116/*: any*/),
                        "type": "TownsquareLearning"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v116/*: any*/),
                        "type": "TownsquareRisk"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v116/*: any*/),
                        "type": "TownsquareDecision"
                      }
                    ]
                  }
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "args": (v117/*: any*/),
            "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseConnection",
            "kind": "LinkedField",
            "name": "workItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedJiraEpicContributesToAtlasGoalInverseEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          (v8/*: any*/),
                          (v82/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "webUrl"
                          }
                        ],
                        "type": "JiraIssue"
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v60/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v63/*: any*/),
              (v23/*: any*/)
            ]
          },
          {
            "args": (v117/*: any*/),
            "filters": [
              "queryContext"
            ],
            "handle": "connection",
            "key": "GoalContentJira_workItems",
            "kind": "LinkedHandle",
            "name": "workItems"
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectName"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectStatus",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "mercuryName"
                              },
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryTargetDateEnd"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "mercuryProjectUrl"
                          },
                          {
                            "kind": "LinkedField",
                            "name": "mercuryProjectOwner",
                            "plural": false,
                            "selections": (v108/*: any*/)
                          },
                          {
                            "kind": "LinkedField",
                            "name": "externalOwner",
                            "plural": false,
                            "selections": [
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "firstName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "lastName"
                              }
                            ]
                          }
                        ],
                        "type": "JiraAlignAggProject"
                      },
                      (v22/*: any*/)
                    ]
                  },
                  (v4/*: any*/)
                ]
              },
              (v23/*: any*/)
            ]
          },
          {
            "args": (v11/*: any*/),
            "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectConnection",
            "kind": "LinkedField",
            "name": "jiraAlignItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphStoreSimplifiedAtlasGoalHasJiraAlignProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": (v90/*: any*/)
              }
            ]
          },
          {
            "alias": "learningsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "LEARNING"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v118/*: any*/),
            "storageKey": "highlights(type:\"LEARNING\")"
          },
          {
            "alias": "risksHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RISK"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v118/*: any*/),
            "storageKey": "highlights(type:\"RISK\")"
          },
          {
            "alias": "decisionsHighlights",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "DECISION"
              }
            ],
            "concreteType": "TownsquareHighlightConnection",
            "kind": "LinkedField",
            "name": "highlights",
            "plural": false,
            "selections": (v118/*: any*/),
            "storageKey": "highlights(type:\"DECISION\")"
          },
          {
            "condition": "includeDraftUpdate",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "TownsquareGoalDraftUpdate",
                "kind": "LinkedField",
                "name": "latestDraftUpdate",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "goal",
                    "plural": false,
                    "selections": [
                      (v34/*: any*/),
                      (v77/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "targetDate",
                        "plural": false,
                        "selections": [
                          (v43/*: any*/),
                          (v70/*: any*/)
                        ]
                      },
                      (v4/*: any*/),
                      {
                        "concreteType": "TownsquareMetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  (v66/*: any*/),
                                  (v67/*: any*/),
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/),
                                      (v50/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v82/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  (v32/*: any*/),
                  {
                    "concreteType": "TownsquareTargetDateInputDraft",
                    "kind": "LinkedField",
                    "name": "targetDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "date"
                      },
                      (v43/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareMetricUpdateInputDraft",
                    "kind": "LinkedField",
                    "name": "metricUpdate",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "targetId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newValue"
                      },
                      (v54/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateNoteInputDraft",
                    "kind": "LinkedField",
                    "name": "updateNotes",
                    "plural": true,
                    "selections": [
                      (v82/*: any*/),
                      (v98/*: any*/),
                      (v19/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareUpdateHighlightInputDraft",
                    "kind": "LinkedField",
                    "name": "highlights",
                    "plural": true,
                    "selections": [
                      (v82/*: any*/),
                      (v98/*: any*/),
                      (v49/*: any*/)
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "provenance_extension"
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": (v58/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "name": "modifiedDate"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "capabilitiesContainerId"
          }
        ],
        "concreteType": "TownsquareProjectAppCapabilities",
        "kind": "LinkedField",
        "name": "projects_capabilities",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "canCreateProject"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4e278a578dc1baffc5e8f0e515cb6c3c8e3538cab4c7248a24696466acefd1a6",
    "metadata": {},
    "name": "GoalPanelQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "afe10b2e21c2a529e608204c3aac423b";

export default node;
